<template>
	<el-row>
		<el-form label-position="right" label-width="80px">
			<el-form-item label="作业名称:">{{this.$route.query.title}}</el-form-item>
			<el-form-item label="提交会员:">{{this.$route.query.userId}}</el-form-item>
			<el-form-item label="会员昵称:">{{this.$route.query.userName}}</el-form-item>
			<el-form-item label="会员等级:">{{this.$route.query.userLevel}}</el-form-item>
			<el-form-item label="批改状态:">
				<span v-if="this.$route.query.correct==0">已批改</span>
				<span v-if="this.$route.query.correct==1">未批改</span>
			</el-form-item>
			<el-form-item label="作业状态:">
				<span v-if="this.$route.query.pass==0">未批改</span>
				<span v-if="this.$route.query.pass==1">合格</span>
				<span v-if="this.$route.query.pass==2">不合格</span>
			</el-form-item>
			<el-form-item label="提交时间:">{{list.subTime}}</el-form-item>
			<el-form-item label="提交内容:"> {{list.context}}</el-form-item>
			<el-form-item label="图片附件:">
				<div style="width: 500px;;display: flex;">
					<div v-for="(item,index) in list.pic" :key="index">
						<el-image :src="item" :preview-src-list="list.pic"
							style="width: 100px;height: 100px;margin: 0 10px;"></el-image>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="视频附件:">
				<video width="700px" height="300px" :src="list.video" controls>
				</video>
				<!-- <video width="300px" height="200px"  loop controls></video> -->
			</el-form-item>
			<el-form-item label="音频附件:">
				<div v-for="(item,index) in list.audio">
					<audio controls loop="loop" preload="auto" :src="item">
					</audio>
				</div>
			</el-form-item>
			<el-form-item label="批改建议:" v-if="this.$route.query.correct==0">{{list.suggestion}}</el-form-item>
			<el-form-item label="批改时间:" v-if="this.$route.query.correct==0">{{list.correctionTime}}</el-form-item>
			<el-form-item>
				<el-button type="primary" @click='queren(1)' v-if="this.$route.query.correct==1">合格</el-button>
				<el-button type="primary" @click='queren(2)' v-if="this.$route.query.correct==1">不合格</el-button>
			</el-form-item>
		</el-form>
		<el-dialog title="确认批阅" :visible.sync="centerDialogVisible" width="30%" center>
			<el-form label-position="right" label-width="90px" :model="info" ref="info">
				<el-form-item label="批改建议:" prop="suggestion" :rules="[{ 
					required: true, message: '请录入您对学员作业的建议', trigger: 'blur' }]">
					<el-input v-model="info.suggestion" type="textarea" placeholder="请录入您对学员作业的建议~500字内" show-word-limit
						maxlength="500"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="infor" @click="centerDialogVisible=false">取消</el-button>
					<el-button type="primary" @click="queren2">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	import httpClient from '../../../util/request.js';
	export default {
		data() {
			return {
				pass: '',
				uploadUrl: httpClient.imgUrl,
				centerDialogVisible: false,
				info: {
					suggestion: '',
				},
				list: {
					context: "",
					correctionTime: '',
					pic: [],
					subTime: "",
					suggestion: "",
					video: '',
					id: '',
					correctionTime: '',
					suggestion: '',
					audio: ''
				}
			}
		},
		methods: {
			queren(num) {
				this.pass = num
				this.centerDialogVisible = true
			},
			queren2() {
				this.$refs.info.validate(valid => {
					if (valid) {
						this.$http.post('/api/course/clrOperationInfo/update', {
							id: this.list.id,
							suggestion: this.info.suggestion,
							pass: this.pass //1合格2不合格
						}).then(res => {
							if (res.data.status == 0) {
								this.$message.success('批阅成功')
								this.$router.push({
									path: './check',
									query: {
										userOperationId: this.$route.query.userOperationId
									}
								})
							} else {
								this.$message.error('批阅失败')
							}
						})
					}
				})
			},
			getInfo() {
				this.$http.post('/api/course/clrOperationInfo/select', {
					entity: {
						userOperationId: this.$route.query.id
					},
					page: {
						pageNum: 1,
						pageSize: 30
					}
				}).then(res => {
					console.log(res.data.data.list[0]);
					if (res.data.data.list[0]) {
						res.data.data.list[0].pic.split(',')
						let list = res.data.data.list[0]
						this.list.subTime = list.subTime
						this.list.context = list.context
						this.list.id = list.id
						this.list.audio = list.audio
						if (list.pic) {
							this.list.pic = (list.pic).split(',')
							// pic.forEach(i => {
							// 	this.list.pic.push({
							// 		url: i
							// 	})
							// })
						}
						this.list.video = list.video
						this.list.suggestion = list.suggestion
						this.list.correctionTime = list.correctionTime
					}
				})
			}
		},
		created() {
			this.getInfo()
			console.log(this.$route.query.correct);
		}
	}
</script>

<style scoped>
	/deep/ .hide .el-upload--picture-card {
		display: none;
	}
</style>
